import React from 'react'
import { useCallback } from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { pushLinkClick } from '@emico/datalayer'
import { isRelative } from '@emico/url'
import { testId } from '@emico/utils'

interface Props extends React.ComponentProps<typeof RouterLink> {
  /**
   * A string representation of the location to link to,
   * created by concatenating the location’s pathname, search, and hash properties
   */
  to: string

  // Link state
  state?: unknown

  // GTM
  /** Tracking event name */
  analyticsName: string
  /** Tracking event category */
  analyticsContext: string
}

const isAnalyticsEnabled =
  process.env.REACT_APP_DISABLE_ANALYTICS_LINK_CLICK !== 'true'

const InternalLink = ({
  to,
  target,
  children,
  state,
  analyticsName,
  analyticsContext,
  onClick,
  ...others
}: Props) => {
  if (!isRelative(to)) {
    to = `/${to}`
  }

  const handleClick = useCallback(
    (e) => {
      if (isAnalyticsEnabled) {
        pushLinkClick(analyticsName, analyticsContext, 'internal')
      }
      if (onClick) {
        onClick(e)
      }
    },
    [analyticsName, analyticsContext, onClick],
  )

  return (
    <RouterLink
      to={
        state
          ? {
              pathname: to,
              state,
            }
          : to
      }
      data-testid={testId(analyticsName, analyticsContext)}
      onClick={handleClick}
      {...others}
    >
      {children}
    </RouterLink>
  )
}

export default InternalLink
